module.exports = tag => [
  'trix-editor',
  'trix-toolbar',
  'action-text-attachment',
  'tfx-trix-hahahahaha'
].includes(tag)
